import { z } from 'zod';

// Phone number validation for SMS setup
export const phoneNumberSchema = z.object({
  phoneNumber: z
    .string()
    .min(1, { message: 'Phone number is required.' })
    .regex(/^\+?[1-9]\d{6,14}$/, {
      message: 'Please enter a valid phone number (e.g., +15551234567).',
    }),
});

// OTP code validation (6-digit for authenticator/SMS)
export const otpCode6Schema = z.object({
  code: z
    .string()
    .length(6, { message: 'Code must be exactly 6 digits.' })
    .regex(/^\d+$/, { message: 'Code must contain only numbers.' }),
});

// OTP code validation (8-digit for email)
export const otpCode8Schema = z.object({
  code: z
    .string()
    .length(8, { message: 'Code must be exactly 8 digits.' })
    .regex(/^\d+$/, { message: 'Code must contain only numbers.' }),
});

// Dynamic OTP schema factory for variable code lengths
export function createOtpSchema(length: number) {
  return z.object({
    code: z
      .string()
      .length(length, { message: `Code must be exactly ${length} digits.` })
      .regex(/^\d+$/, { message: 'Code must contain only numbers.' }),
  });
}

// Backup code validation (8 alphanumeric characters, e.g. "951D46D1")
export const backupCodeSchema = z.object({
  code: z
    .string()
    .length(8, { message: 'Backup code must be exactly 8 characters.' })
    .regex(/^[a-zA-Z0-9]+$/, { message: 'Backup code must contain only letters and numbers.' }),
});

export type PhoneNumberInput = z.infer<typeof phoneNumberSchema>;
export type OtpCode6Input = z.infer<typeof otpCode6Schema>;
export type OtpCode8Input = z.infer<typeof otpCode8Schema>;
